declare var process: any;
declare var jimdoData: any;
declare var script_basisID: any;
declare var cc_: any;
declare var webDomain: string;

if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.websiteData' instead");
}

interface WebsiteDataStructure {
    [key: string]: any;
    cmsLanguage: string;
    market: string;
    cdnUrl: string;
    webUrl: string;
    notification: {
        [key: string]: any;
    };
    notificationData: {
        [key: string]: any;
    };
    cpContactUrl: string;
}

class Data {
    constructor(protected data: WebsiteDataStructure) {
    }
    getId() {
        let websiteId: string;
        if ('undefined' !== typeof script_basisID) {
            websiteId = script_basisID;
        } else if (/^\/app\/[0-9]+\//.test(location.pathname)) {
            websiteId = location.pathname.match(/^\/app\/([0-9]+)\//)[1];
        }
        return websiteId;
    }
    getData<T>(section: string): T {
        return this.data[section];
    }
    getLanguageCode() {
        return (this.data.cmsLanguage) ? this.data.cmsLanguage.toString() : '';
    }
    getLanguage() {
        return this.getLanguageCode().split('_')[0].toString();
    }
    getMarket() {
        return this.getLanguageCode().split('_')[1].toString().toLowerCase();
    }
    getCdnUrl() {
        return this.data.cdnUrl;
    }
    getWebUrl() {
        return this.data.webUrl;
    }
    getWebDomain() {
        return webDomain;
    }
    getNotificationData<T>(section: string): T {
        if (this.data.notificationData[section]) {
            return this.data.notificationData[section];
        } else {
            return this.data.notification[section];
        }
    }
    getCmsUrl() {
        return cc_.properties.cmsUrl;
    }
    getCpContactUrl() {
        return this.data.cpContactUrl;
    }
}

export = new Data(jimdoData);



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/websiteData.ts
 **/